import {createListFromObject} from "@utilities/Types/listUtilities";
import {GRADE_LEVEL_LIST} from "../Student/studentConstants";

export {GRADE_LEVEL_LIST};

export const AVAILABILITY = {
    "In Stock": 1,
    "Obtainable": 2,
    "Special Order Request": 3,
};

export const AVAILABILITY_LIST = createListFromObject(AVAILABILITY);

export const FORMAT = {
    "Braille (EBAE)": 0,
    "Large Print": 1,
    "Braille (UEB)": 15,
    "Braille (Nemeth)": 16,
    "Uncontracted": 23,
    "Digital": 31,
};

export const FORMAT_LIST = createListFromObject(FORMAT);

export const FORMAT_FULL = {
    ...FORMAT,
    "Large Print Master": 7,
    "Braille (S)": 10,
    "Large Print (S)": 11,
    "DAISY Text": 27,
};

export const FORMAT_FULL_LIST = createListFromObject(FORMAT_FULL);


export const ORDER_STATUS = {
    "Order Received From Patron": 1,
    "Request Physical Copy": 2,
    "Physical Copy Received": 3,
    "Generate Purchase Order": 4,
    "Order Sourced Completed": 5,
    "Produce Internally": 6,
    "Order Sent To Vendor": 7,
    "Partial Order Received" : 8,
    "Full Order Received" : 9,
    "Add To Catalog Inventory" : 10,
    "Print Bar Code" : 11,
    "Print Mailing Label" : 12,
    "Ready To Mail" : 13,
    "Mailed" : 14,
    "Order Complete" : 15,
    "Order Cancelled By Patron" : 16,
    "Order Cancelled By FIMC" : 17,
};

export const ORDER_STATUS_LIST = createListFromObject(ORDER_STATUS);

export const TERMINAL_ORDER_STATUS = {
    "Order Complete" : 15,
    "Order Cancelled By Patron" : 16,
    "Order Cancelled By FIMC" : 17,
};

export const TERMINAL_ORDER_STATUS_LIST = createListFromObject(TERMINAL_ORDER_STATUS);

export const FUNDING_SOURCE = {
    "0816": 1,
    "0817": 2,
    "Quota": 3,
    "Internal Production": 4,
};

export const FUNDING_SOURCE_LIST = createListFromObject(FUNDING_SOURCE);


export const COPY_STATUS_MANUALLY_SET = {
    "Available": 0,
    "CheckedOut": 2,
    "PartiallyAvailable": 5,
    "OnOrder" : 6,
    "Lost": 4,
    "Purged": 7,
    "Incomplete": 8,
    "Unavailable": 9,
    "SeeNotes" : 10,
    "PartiallyCheckedOut" : 11,
};

export const COPY_STATUS_MANUALLY_SET_LIST = createListFromObject(COPY_STATUS_MANUALLY_SET);

export const COPY_STATUS = {
    ...COPY_STATUS_MANUALLY_SET,
    "Reserved": 1,
    "OnOrder": 6,
};

export const COPY_STATUS_LIST = createListFromObject(COPY_STATUS);



export const QUEUE_STATUS = {
    Waitlist: 0,
    Reserved: 1,
    ReadyForCheckout: 2,
    InProcess: 3,
    Mailed: 4,
    OrderReceived: 5,
    OrderSentToVendor: 6,
    OrderReceivedFromVendor: 7,
    OrderPartiallyMailed: 8,
    OrderFullyMailed: 9,
    OrderCanceled: 10
}

export const QUEUE_STATUS_LIST = createListFromObject(QUEUE_STATUS);


export const SYSTEM_TYPES = {
    "Textbooks": 0,
    "LoanLibrary": 1,
    "APH": 2,
    "Braillers": 3,
};

export const SYSTEM_TYPES_LIST = createListFromObject(SYSTEM_TYPES);

export const SYSTEM_TYPES_PRODUCTION = {
    "Textbooks": 0,
}
export const SYSTEM_TYPES_PRODUCTION_LIST = createListFromObject(SYSTEM_TYPES_PRODUCTION);
